import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';

import TouchableElement from '@components/common/touchableElement';
import { workerTypeStatusNames, workerType } from '@helpers';

import Loading from '@components/loading';

import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';

export default ({ C, connector, goBack }) => {
  const renderContent = () => {
    const machineConnector = connector?.connectorDetails?.status?.find((c) => c.workerType === workerType.MACHINES) || {};

    if (!connector.loaded || machineConnector?.status == workerTypeStatusNames.Onboarding) {
      return (
        <View
          style={{
            width: '100%',
            height: scale(200),
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center',
            marginBottom: scale(58),
          }}
        >
          <Loading background={'transparent'} />
        </View>
      );
    }

    return (
      <View style={{ marginVertical: scale(20), alignItems: 'center' }}>
        <Svg icon={'errorBig'} width={scale(44)} height={scale(40)} color={C('Label/Light/Error')} />
        <Text style={[{ color: C('Label/Light/Primary'), width: '100%', textAlign: 'center', marginTop: scale(16) }, font.Headline]}>
          {i18n.t('Your Connector is Offline')}
        </Text>
        <Text style={[{ color: C('Label/Light/Tertiary'), width: '100%', textAlign: 'center', marginTop: scale(48) }, font.Body]}>
          {i18n.t('Cannot connect to the Smart Factory Machine Connector')}
        </Text>
      </View>
    );
  };

  return (
    <View>
      <View>
        <View
          style={{
            width: '100%',
            zIndex: 1000,
            height: scale(58),
          }}
        >
          <View style={{ position: 'absolute', zIndex: 1000, right: 0 }}>
            <TouchableElement
              onPress={() => {
                goBack();
              }}
            >
              {({ boxStyle, pressHoverColor }) => (
                <View style={[boxStyle, { padding: scale(15), flexDirection: 'row' }]}>
                  <Text style={[{ color: C(pressHoverColor('System/Light/Blue')), marginLeft: scale(7) }, font.Body]}>{i18n.t('Close')}</Text>
                </View>
              )}
            </TouchableElement>
          </View>
        </View>
      </View>
      {renderContent()}
    </View>
  );
};
